
export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const months = [
  'All',
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
